import React from 'react'
import Button from '../Button'

type Props = {
    message: string,
    onConfirm: Function,
    onCancel: Function
}

export default function LoginModalConfirm({ message, onConfirm, onCancel }: Props) {
    const handleConfirm = () => {
        onConfirm();
    }
    const handleCancel = () => {
        onCancel();
    }

    return (
        <div>
            <p>{message}</p>
            <div className='button-group'>
                <Button className='btn-new btn-new-dynamic btn-new-secondary'
                    label='Cancel'
                    onClick={handleCancel} />
                <Button className='btn-new btn-new-dynamic'
                    label='Login'
                    onClick={handleConfirm} />
            </div>
        </div>
    )
}